import { render, staticRenderFns } from "./PublishRulesModal.vue?vue&type=template&id=88773cb0"
import script from "./PublishRulesModal.vue?vue&type=script&lang=js"
export * from "./PublishRulesModal.vue?vue&type=script&lang=js"
import style0 from "./PublishRulesModal.vue?vue&type=style&index=0&id=88773cb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports